import { useState } from "react";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { LIST_ICONS } from "@/components/todo/ListIcon";

export const IconPicker = ({ value, onPick, children, testId }) => {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent align="start" className="w-72 bg-t-card border-t-line rounded-2xl p-3 shadow-xl" data-testid={testId}
        onClick={(e) => e.stopPropagation()}>
        <p className="text-[10px] font-semibold tracking-[0.2em] uppercase text-t-muted px-1 pb-2">Choose an icon</p>
        <div className="grid grid-cols-4 gap-1.5">
          {Object.entries(LIST_ICONS).map(([key, { Icon, label }]) => (
            <button key={key} type="button" title={label} data-testid={`icon-option-${key}`}
              onClick={() => { onPick(key); setOpen(false); }}
              className={`flex flex-col items-center gap-1 py-2 rounded-xl text-[10px] transition-colors ${value === key ? "bg-t-primary text-white" : "text-t-c4 hover:bg-t-surface"}`}>
              <Icon className="h-5 w-5" />
              <span className="truncate w-full text-center px-0.5">{label}</span>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
